// extracted by mini-css-extract-plugin
export default {"image":"Carousel_image__LmJM7","title":"Carousel_title__iwHCm"};